var exports = {
  "SP": "closeMarkersDialogButton__vgfgzR",
  "F1": "markersWrapper__QhVNdX",
  "Lv": "fileMarkersWrapper__N5gdJR",
  "se": "markersDialogActive__C9Pn0N",
};

module.exports = exports;
